export let TimelineGridEventPlaceholderCssVars = /*#__PURE__*/function (TimelineGridEventPlaceholderCssVars) {
  TimelineGridEventPlaceholderCssVars["xPosition"] = "--x-position";
  TimelineGridEventPlaceholderCssVars["width"] = "--width";
  return TimelineGridEventPlaceholderCssVars;
}({});